/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { createContext, useContext } from 'react';

type SideNavContextType = {
  shouldOverlayOnInteraction: boolean;
  isExpanded: boolean;
  isHovered: boolean;
  onPinButtonClick?: () => void;
};

export const SideNavContext = createContext<SideNavContextType | null>(null);

export const useSideNavContext = () => {
  const context = useContext(SideNavContext);
  if (!context) {
    throw new Error(
      'SideNavigation subcomponents must be wrapped in <SideNavigation /> component',
    );
  }
  return context;
};

type SideNavCategoryContextType = {
  activeIndex: number | null;
  getItemProps: (
    userProps?: React.HTMLProps<HTMLElement>,
  ) => Record<string, unknown>;
};

export const SideNavCategoryContext =
  createContext<SideNavCategoryContextType | null>(null);

export const useSideNavCategoryContext = () => {
  return useContext(SideNavCategoryContext);
};
